export default __webpack_public_path__ + "static/media/blk.be61b624.svg";